import { defineMessages } from 'react-intl-next';

export default defineMessages({
	title: {
		id: 'project-pages.improvement.title',
		defaultMessage: 'Project pages',
		description: 'Page title for the Project pages feature',
	},
	headingInfo: {
		id: 'project-pages.improvement.heading-info',
		defaultMessage: "Capture your team's knowledge and improve the way you get work done.",
		description: 'Information about the value of the Project pages feature',
	},
	headingInfoV2: {
		id: 'project-pages.improvement.heading-info-v2',
		defaultMessage: "Create one place for all your team's project documents",
		description: 'Information about the value of the Project pages feature',
	},
	feature1: {
		id: 'project-pages.improvement.feature1',
		defaultMessage: 'Access and create documents without leaving Jira',
		description:
			'First bulleted feature that explains the value of using Confluence alongside Jira',
	},
	feature2: {
		id: 'project-pages.improvement.feature2',
		defaultMessage: 'Templates for meetings, sprint plans, and more',
		description:
			'Second bulleted feature that explains the value of using Confluence alongside Jira',
	},
	feature3: {
		id: 'project-pages.improvement.feature3',
		defaultMessage: 'Sync documents to Jira for automatic updates',
		description:
			'Third bulleted feature that explains the value of using Confluence alongside Jira',
	},
	termsAndConditionsV2: {
		id: 'project-pages.improvement.terms-and-conditions-v2',
		defaultMessage:
			"By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.",
		description:
			'Links to the Terms and Conditions and Privacy Policy that the user must agree to before starting their Confluence trial',
	},
	tryItNow: {
		id: 'project-pages.improvement.try-it-now',
		defaultMessage: 'Try it now',
		description: 'Call to action for the user to start their Confluence trial',
	},
	poweredBy: {
		id: 'project-pages.improvement.powered-by',
		defaultMessage: 'Powered by',
		description:
			'Prefix to the footer indicating the Project pages feature is powered by Confluence',
	},
	poweredByTooltip: {
		id: 'project-pages.improvement.powered-by.tooltip',
		defaultMessage: 'Open Confluence in a new tab',
		description:
			'Tooltip on the Confluence logo in the powered by footer to indicate that clicking will open Confluence in a new tab',
	},
	previewTeaser: {
		id: 'project-pages.improvement.preview-teaser',
		defaultMessage: 'Unlock templates, project pages, and more.',
		description: 'Teaser for Confluence touchpoint',
	},
	learnMoreButton: {
		id: 'project-pages.improvement.learn-more-button',
		defaultMessage: 'Learn more',
		description: 'Button label for Confluence touchpoint',
	},
	tryLozenge: {
		id: 'project-pages.improvement.try-lozenge',
		defaultMessage: 'try',
		description: 'This text appears as a way to encourage the user to try Confluence',
	},
	tryButton: {
		id: 'project-pages.improvement.try-button',
		defaultMessage: 'Try this template in Confluence',
		description: 'Button label for Confluence touchpoint',
	},
	tryOnDemandButton: {
		id: 'project-pages.improvement.try-on-demand-button',
		defaultMessage: 'Try it free',
		description:
			'Button label for Confluence touchpoint when users can activate Confluence for free',
	},
	templatesPreExpandTitle: {
		id: 'project-pages.improvement.templates.pre-expand.title',
		defaultMessage: 'Preview templates',
		description: 'Title for list of page templates',
	},
	templatesPreExpandSubtitle: {
		id: 'project-pages.improvement.templates.pre-expand.subtitle',
		defaultMessage: 'Popular with teams like yours',
		description: 'Information for list of page templates',
	},
	templatesPreExpandMore: {
		id: 'project-pages.improvement.templates.pre-expand.more',
		defaultMessage: 'Explore more templates',
		description: 'Link to documentation about Confluence templates',
	},
	templatesPostExpandTitle: {
		id: 'project-pages.improvement.templates.post-expand.title',
		defaultMessage: 'Create a page',
		description: 'Title for list of page templates',
	},
	templatesPostExpandSubtitle: {
		id: 'project-pages.improvement.templates.post-expand.subtitle',
		defaultMessage: 'Popular templates',
		description: 'Information for list of page templates',
	},
	templatesPostExpandMore: {
		id: 'project-pages.improvement.templates.post-expand.more',
		defaultMessage: 'More templates',
		description: 'Link to browse templates',
	},
	templatesPostExpandMoreTooltip: {
		id: 'project-pages.improvement.templates.post-expand.more.tooltip',
		defaultMessage: 'View all templates in Confluence',
		description: 'Tooltip for link to browse templates',
	},
	connectSpaceTooltip: {
		id: 'project-pages.improvement.templates.template.disabled-tooltip',
		defaultMessage: 'Connect a Confluence space first',
		description:
			'Tooltip informing user that template creation is disabled until they connect a space',
	},
	blankPageTemplateName: {
		id: 'project-pages.improvement.templates.blank-page.name',
		defaultMessage: 'Blank page',
		description: 'Title of a blank template',
	},
	blankPageTemplateDescription: {
		id: 'project-pages.improvement.templates.blank-page.description',
		defaultMessage: 'Start a page from scratch.',
		description: 'Description of a blank template',
	},
	productRequirementsTemplateName: {
		id: 'project-pages.improvement.templates.product-requirements.name',
		defaultMessage: 'Product requirements',
		description: 'Title of a template',
	},
	productRequirementsTemplateDescription: {
		id: 'project-pages.improvement.templates.product-requirements.description',
		defaultMessage: 'Define, track and scope requirements for your product or feature.',
		description: 'Description for a template',
	},
	decisionTemplateName: {
		id: 'project-pages.improvement.templates.decision.name',
		defaultMessage: 'Decision',
		description: 'Title of a template',
	},
	decisionTemplateDescription: {
		id: 'project-pages.improvement.templates.decision.description',
		defaultMessage: 'Record important project decisions and communicate them with your team.',
		description: 'Description for a template',
	},
	meetingNotesTemplateName: {
		id: 'project-pages.improvement.templates.meeting-notes.name',
		defaultMessage: 'Meeting notes',
		description: 'Title of a template',
	},
	meetingNotesTemplateDescription: {
		id: 'project-pages.improvement.templates.meeting-notes.description',
		defaultMessage: 'Set meeting agendas, take notes, and share action items with your team.',
		description: 'Description for a template',
	},
	retrospectiveTemplateName: {
		id: 'project-pages.improvement.templates.retrospective.name',
		defaultMessage: 'Retrospective',
		description: 'Title of a template',
	},
	retrospectiveTemplateDescription: {
		id: 'project-pages.improvement.templates.retrospective.description',
		defaultMessage:
			'What went well? What could have gone better? Crowdsource improvements with your team.',
		description: 'Description for a template',
	},
	tutorialPageDescription: {
		id: 'project-pages.improvement.templates.tutorial.description',
		defaultMessage: 'Learn how to edit a page.',
		description: 'Description for the tutorial page',
	},
	tutorialPageName: {
		id: 'project-pages.improvement.templates.tutorial.name',
		defaultMessage: 'Welcome to Project Pages!',
		description: 'Title of the tutorial page',
	},
});
